import React, { useState, useEffect } from "react";
import { CiCircleRemove } from "react-icons/ci";
import { IoIosArrowUp, IoIosArrowDown } from "react-icons/io";
import Slider from "react-slider";
import "./styles.css";
import { BASE_URL } from "../../constant";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { FaArrowDown } from "react-icons/fa";
import { MdKeyboardArrowDown, MdKeyboardArrowRight } from "react-icons/md";

const FilterSection2 = ({
  setCurrentProducts,
  scheme,
  setScheme,
  isFilterClicked,
  setIsFilterClicked,
  setNavigatedCategory,
  setSelectedCategory,
  categories,
  colors,
  sizes,
  brands,
}) => {
  const navigate = useNavigate();
  const [showSidebar, setShowSidebar] = useState(false);
  const [dropdownStates, setDropdownStates] = useState({});
  const [stockStatus, setStockStatus] = useState("");
  const [activeCategory, setActiveCategory] = useState(null);

  const [showAll, setShowAll] = useState({
    categories: false,
    colors: false,
    brands: false,
    sizes: false,
  });

  // Function to fetch products based on the category or item
  const fetchProducts = (categoryName, item, type) => {
    setIsFilterClicked(true);
    let url = "";

    if (type === "color") {
      url = `${BASE_URL}/api/customProducts/color?color=${item}`;
    } else if (type === "brand") {
      url = `${BASE_URL}/api/customProducts/brand?brand=${item}`;
    } else if (type === "size") {
      url = `${BASE_URL}/api/customProducts/size?size=${item}`;
    } else if (type === "subcategory") {
      url = `${BASE_URL}/api/customProducts/subcategory?category=${categoryName}&subcategory=${item}`;
      console.log(categoryName);
    } else if (type === "category" && categoryName) {
      url = `${BASE_URL}/api/customProducts/category?category=${categoryName}`;
      // console.log("object actegroy calddhb");
    } else {
      return;
    }

    fetch(url)
      .then((response) => response.json())
      .then((data) => {
        setCurrentProducts(data);
      })
      .catch((error) => console.error("Error fetching products:", error));
  };

  const handleDropdownToggle = (categoryName, item, type, subcategories) => {
    setSelectedCategory(categoryName);
    setIsFilterClicked(true);
    setActiveCategory((prev) => (prev === categoryName ? null : categoryName));

    if (type === "category") {
      fetchProducts(categoryName, item, "category");
    }
    setNavigatedCategory(item);

    fetchProducts(categoryName, item, type);
    setNavigatedCategory(item);
    setScheme("");

    // Update URL with the type and item/category name
    const searchParams = new URLSearchParams();
    // console.log("item", item);
    if (type === "category") {
      searchParams.set("category", categoryName);
      searchParams.delete("subcategory");
    } else if (type === "subcategory") {
      searchParams.set("subcategory", item);
      searchParams.delete("category");
    } else if (type === "color") {
      searchParams.set("color", item);
    } else if (type === "brand") {
      searchParams.set("brand", item);
    } else if (type === "size") {
      searchParams.set("size", item);
      searchParams.delete("category");
    }

    // console.log(searchParams);
    // Navigate with the updated query params
    navigate(`/shop?${searchParams.toString()}`);
  };

  const handleArrowClick = (categoryName) => {
    setActiveCategory((prev) => (prev === categoryName ? null : categoryName));
  };

  const handleStockStatusChange = (status) => {
    setStockStatus(status);
  };

  const handleSchemeChange = (selectedscheme) => {
    if (scheme == selectedscheme) {
      setScheme("");
    } else {
      setScheme(selectedscheme);
    }
  };

  const toggleShowAll = (key) => {
    setShowAll((prev) => ({ ...prev, [key]: !prev[key] }));
  };

  const renderFilterSection = (title, data, key, type) => (
    <div className="mb-3">
      <h4>{title}</h4>
      {data?.slice(0, showAll[key] ? data.length : 3)?.map((item, index) => (
        <div key={index}>
          {/* Main Category */}
          <div className="dropdown d-flex">
            <span
              onClick={() => {
                handleDropdownToggle(
                  item.categoryName || item,
                  item.categoryName || item,
                  type,
                  item.subcategoryList
                );
                navigate(`/shop?category=${item.categoryName}`);
              }}
            >
              {item.categoryName || item}
            </span>
            {item.categoryName && (
              <span
                onClick={() => handleArrowClick(item.categoryName)}
                style={{ cursor: "pointer" }}
              >
                {activeCategory === item.categoryName ? (
                  <MdKeyboardArrowDown />
                ) : (
                  <MdKeyboardArrowRight />
                )}
              </span>
            )}
          </div>

          {/* Subcategories */}
          {activeCategory === item.categoryName &&
            item.subcategoryList?.map((subItem) => (
              <div
                key={subItem.subCategoryId}
                className="subcategory-item"
                onClick={(e) => {
                  e.stopPropagation();
                  // console.log("Clicked Subcategory:", subItem.subCategoryName);
                  handleDropdownToggle(
                    item.categoryName,
                    subItem.subCategoryName,
                    "subcategory",
                    []
                  );
                }}
              >
                {subItem.subCategoryName}
              </div>
            ))}
        </div>
      ))}

      {/* Show More Button */}
      {data?.length > 3 && (
        <button className="show-more-btn" onClick={() => toggleShowAll(key)}>
          {showAll[key] ? "Show Less" : "Show More"}
        </button>
      )}
    </div>
  );

  return (
    <div id="sidebar">
      <div className="dropdown-container">
        {renderFilterSection(
          "Shop By Categories",
          categories,
          "categories",
          "category"
        )}
        {renderFilterSection("Shop By Sizes", sizes, "sizes", "size")}
        {renderFilterSection("Shop By Colors", colors, "colors", "color")}
        {renderFilterSection("Shop By Brands", brands, "brands", "brand")}

        <div className="mt-3">
          <div className="d-flex align-items-center gap-2 mb-3">
            <input
              type="checkbox"
              className="filter-checkbox"
              checked={scheme === "offered"}
              onClick={() => handleSchemeChange("offered")}
            />
            <p style={{ fontSize: "20px", marginBottom: "0px" }}>
              Offered Products
            </p>
          </div>
          <div className="d-flex align-items-center gap-2">
            <input
              type="checkbox"
              className="filter-checkbox"
              checked={scheme === "lightning"}
              onClick={() => handleSchemeChange("lightning")}
            />
            <p style={{ fontSize: "20px", marginBottom: "0px" }}>
              Lightning Deals
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FilterSection2;
